/**
 * ST2086 mastering template files (v9b, Aug 2025) embedded for browser use.
 * Mirrors 2086_extractor/ST2086_Templates_v9b_Aug2025 exactly.
 */
(function (global) {
  'use strict';
  const ST2086_TEMPLATES = {
    "2086_p3_1000nits-0001_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.680</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.320</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.265</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.690</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.150</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.060</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.0001</md:LuminanceMin>
		<md:LuminanceMax>1000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_p3_1000nits-005_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.680</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.320</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.265</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.690</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.150</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.060</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.005</md:LuminanceMin>
		<md:LuminanceMax>1000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_p3_1000nits_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.680</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.320</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.265</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.690</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.150</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.060</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.001</md:LuminanceMin>
		<md:LuminanceMax>1000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_p3_2000nits-0001_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.680</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.320</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.265</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.690</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.150</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.060</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.0001</md:LuminanceMin>
		<md:LuminanceMax>2000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_p3_2000nits_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.680</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.320</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.265</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.690</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.150</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.060</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.001</md:LuminanceMin>
		<md:LuminanceMax>2000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_p3_4000nits_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.680</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.320</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.265</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.690</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.150</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.060</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.005</md:LuminanceMin>
		<md:LuminanceMax>4000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_rec2020_1000nits-0001_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.7080</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.2920</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.1700</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.7970</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.1310</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.0460</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.0001</md:LuminanceMin>
		<md:LuminanceMax>1000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_rec2020_1000nits-005_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.7080</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.2920</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.1700</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.7970</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.1310</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.0460</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.005</md:LuminanceMin>
		<md:LuminanceMax>1000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_rec2020_1000nits_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.7080</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.2920</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.1700</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.7970</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.1310</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.0460</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.001</md:LuminanceMin>
		<md:LuminanceMax>1000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_rec2020_2000nits-0001_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.7080</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.2920</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.1700</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.7970</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.1310</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.0460</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.0001</md:LuminanceMin>
		<md:LuminanceMax>2000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_rec2020_2000nits_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.7080</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.2920</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.1700</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.7970</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.1310</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.0460</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.001</md:LuminanceMin>
		<md:LuminanceMax>2000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
    "2086_rec2020_4000nits_v9.xml": `<?xml version="1.0" encoding="UTF-8"?>
<md:Picture xmlns:md="http://www.movielabs.com/md">
	<md:MasteredColorVolume>
		<md:PrimaryRChromaticity>
			<md:ChromaticityCIEx>0.7080</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.2920</md:ChromaticityCIEy>
		</md:PrimaryRChromaticity>
		<md:PrimaryGChromaticity>
			<md:ChromaticityCIEx>0.1700</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.7970</md:ChromaticityCIEy>
		</md:PrimaryGChromaticity>
		<md:PrimaryBChromaticity>
			<md:ChromaticityCIEx>0.1310</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.0460</md:ChromaticityCIEy>
		</md:PrimaryBChromaticity>
		<md:WhitePointChromaticity>
			<md:ChromaticityCIEx>0.3127</md:ChromaticityCIEx>
			<md:ChromaticityCIEy>0.3290</md:ChromaticityCIEy>
		</md:WhitePointChromaticity>
		<md:LuminanceMin>0.005</md:LuminanceMin>
		<md:LuminanceMax>4000.00</md:LuminanceMax>
	</md:MasteredColorVolume>
	<md:ColorEncoding>
		<md:Primaries>BT2020</md:Primaries>
		<md:TransferFunction>ST2084</md:TransferFunction>
		<md:ColorDifferencing>BT2020</md:ColorDifferencing>
	</md:ColorEncoding>
	<md:LightLevel>
		<md:ContentMax interpretation="MaxCLL">0</md:ContentMax>
		<md:FrameAverageMax interpretation="MaxFALL">0</md:FrameAverageMax>
	</md:LightLevel>
</md:Picture>`,
  };
  const api = { ST2086_TEMPLATES: ST2086_TEMPLATES };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (global) global.ST2086_TEMPLATES = ST2086_TEMPLATES;
})(typeof window !== 'undefined' ? window : globalThis);
